import { render, staticRenderFns } from "./StandardTable.vue?vue&type=template&id=27a265ce&scoped=true&"
import script from "./StandardTable.vue?vue&type=script&lang=js&"
export * from "./StandardTable.vue?vue&type=script&lang=js&"
import style0 from "./StandardTable.vue?vue&type=style&index=0&id=27a265ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a265ce",
  null
  
)

export default component.exports